/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Nikhil Mahashabde",
  title: "Hi, I'm Nikhil",
  subTitle: emoji(
    "Electrical Engineer turned software enthusiast, 🚀 building Web applications with Typescript / React / Node and on a quest to master the world of ASP.NET Core & AWS."
  ),
  ///////// CHANGE LATER NIKHIL ///////////// ///////// CHANGE LATER NIKHIL ///////////// ///////// CHANGE LATER NIKHIL /////////////
  resumeLink:
    "https://drive.google.com/file/d/1rSjz8LItooTPsUtcxT02l2jNqiEgKEpD/view?usp=drive_link", // Set to empty to hide the button

  ///////// CHANGE LATER NIKHIL ///////////// ///////// CHANGE LATER NIKHIL /////////////
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/NikhilMahashabde",
  linkedin: "https://www.linkedin.com/in/nikhil-mahashabde-5b470236/",
  gmail: "nikhil.mahashabde@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "SOFTWARE ENGINEER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Competent in various back-end frameworks including Node.js, Flask and ASP.NET Core."
    ),
    emoji(
      "⚡ Developing UIs using front-end technologies like React with TypeScript & Redux, Bootstrap and Chakra UI."
    ),
    emoji(
      "⚡  Familiarity with crafting REST APIs, and acquainted with integrating external services such as Auth0, OpenAI, and SQL/NOSQL to enhance application functionalities."
    ),
    emoji(
      "⚡  Eager Learner and Adaptive Problem Solver: Proficient in swiftly acquiring new skills and technologies, coupled with a strong problem-solving ability, making me well-equipped to tackle diverse challenges in the software development realm."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "ASP.NET Core",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },

    // {
    //   skillName: "sass",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },

    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql & NoSql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    // {
    //   skillName: "aws",
    //   fontAwesomeClassname: "fab fa-aws"
    // },
    // {
    //   skillName: "firebase",
    //   fontAwesomeClassname: "fas fa-fire"
    // },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    // {
    //   skillName: "docker",
    //   fontAwesomeClassname: "fab fa-docker"
    // }
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "General Assembly",
      logo: require("./assets/images/GAlogo.png"),
      subHeader: "Software Engineering",
      duration: "2023",
      descBullets: [
        "Front-End Skills: Acquired expertise in building dynamic user interfaces using React, JavaScript, and UI Libraries.",
        "Developed strong back-end capabilities using Node.js with Express and Python with Flask, SQL/NoSQL, enabling efficient server-side application development.",
        "Gained hands-on experience in project planning, version control with GitHub, and successful deployment, while understanding the software development lifecycle."
      ]
    },
    {
      schoolName: "University of New South Wales (UNSW)",
      logo: require("./assets/images/UNSWLogo.png"),
      subHeader:
        "Bachelor of Electrical Engineering (Hons) & Bachelor of Commerce (Mgmt)",
      duration: "2010-2015",
      desc: "Graduated Engineering with Hons, graduated Commerce with Distinction",
      descBullets: [
        "Relevant courses include Computer Science, Digital circuits and systems, Embedded systems, Maths, Physics and General Engineering projects.",
        "Commerce courses focused in Strategic, Financial and General Management."
      ]
    },
    {
      schoolName: "Royal Melbourne Institute of Tecnology (RMIT)",
      logo: require("./assets/images/RMITlogo.png"),
      subHeader: "Grad.Dip Project Management",
      duration: "2018-2019",
      desc: "Managing product projects on time, budget and quality",
      descBullets: [
        "Graduated with Distinction.",
        "Courses taken in Product Development, Project Planning, Scope Development and Financial Management."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: null,
      company: "General Assembly",
      companylogo: require("./assets/images/GAlogo.png"),
      date: "2023 - Present",
      desc: "Past & current projects",
      descBullets: [
        "Inspirations Travel Planner: Utilizing OpenAI, I engineered a travel planning app that formulates personalized travel itineraries. My expertise in Express, React, MongoDB, and authentication integration ensured a seamless user experience.",
        "Manufacturing Planning App: I developed a robust manufacturing planning tool, incorporating Jinja Templates, Bootstrap, Python, Flask, and a PostgreSQL database. The result was a streamlined solution for optimizing production processes",
        "Trip Tales Web App: As part of a collaborative team, beyond coding, my roles included debugging, meticulous code reviews, seamless merging, and effective product/project management"
      ]
    },
    {
      role: "Manufacturing Manager",
      company: "Inlite",
      companylogo: require("./assets/images/Inlite.png"),
      date: "2020 - Present",
      descBullets: [
        "Successfully led the transition of our manufacturing system to Rootstock & Salesforce, streamlining operations, enhancing data visibility, and improving overall efficiency.",
        "Led product design and development, demonstrating innovative thinking, technical problem solving and market-driven solutions.",
        "Project-managed purchasing operations and subcontractors for electro-mechanical services.",
        "Led a team of 6, fostering collaboration and meeting project milestones on time."
      ]
    },
    {
      role: "Electrical Engineer",
      company: "Gentech Lighting",
      companylogo: require("./assets/images/Gentech.png"),
      date: "2015 - 2020",
      descBullets: [
        "Implemented Electrical standards to refresh aging Products.",
        "Created a compliance register Application using Excel & VBA.",
        "Project Managed the design and development of 6 products lines.",
        "Managed and developed a team of 3 members from 2016."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title:
        "1st Place - 2010 Taiwan International Science Fair ( Computer Science ) ",
      subtitle:
        "Won first place in the Computer science category for development of 'Spynik project' ",
      image: require("./assets/images/tisf.png"),
      imageAlt: "TISF Logo",
      footerLink: [
        // {
        //   name: "Certification",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        // }
      ]
    },
    {
      title: "Realise the Dream - Scholarship",
      subtitle:
        "Won the Dairy NZ Realise the Dream award for 'Spynik', a software/hardare solution to monitor activity digital actvity and implement home automation controls over a webserver",
      image: require("./assets/images/RTDlogob.png"),
      imageAlt: "Release The Dream Logo",
      footerLink: [
        // {
        //   name: "View Google Assistant Action",
        //   url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        // }
      ]
    },

    {
      title: "Programming in C",
      subtitle: "Completed Certifcation from NIIT for programming in C",
      image: require("./assets/images/Niit.png"),
      imageAlt: "NIIT",
      footerLink: [
        // {name: "Certification", url: ""}
        // // {
        // //   name: "Final Project",
        // //   url: "https://pakistan-olx-1.firebaseapp.com/"
        // // }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("About Me ☎️"),
  subtitle:
    "Discuss an oportunity or just want to say hi? My Inbox is open for all",
  number: "0434 286 763",
  email_address: "nikhil.mahashabde@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
